import { render, staticRenderFns } from "./SeoDomainAuthorityContent.vue?vue&type=template&id=0a595ed8"
import script from "./SeoDomainAuthorityContent.vue?vue&type=script&lang=js"
export * from "./SeoDomainAuthorityContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports